export enum PatientGoalControlTypeEnum {
    SLIDER = 'slider',
    SELECT = 'select',
    NUMBER = 'number',
    RADIO = 'radio'
}
